// import React, { useEffect, useState } from 'react';
// import { Button, Collapse, Grid, Input, Select, Table, Text, TextInput } from '@mantine/core';
// import { IconArrowLeft, IconSearch, IconArrowRight, IconPrinter } from '@tabler/icons-react';
// import { useDebounce } from '../Hooks/useDebounce';
// import classes from './ReceivedRestockRequest.module.css'
// import NavBar from '../Navigation/navBar';
// import brandsData from './brandsData.json'
// import departmentsData from './departmentsData.json';


 
// const RestockRequests: React.FC = () => {
   
//     const [tableData, setTableData] = useState<any[]>([]);
//     const [mainTableData, setMainTableData] = useState<any[]>([]);
//     const [page, setPage] = useState(1);
//     const [limit, setLimit] = useState(10);
//     const [totalPages, setTotalPages] = useState(1);
//     const [brand, setBrand] = useState('');
//     const [department, setDepartment] = useState('');
//     const [openedRows, setOpenedRows] = useState<{ [index: number]: boolean }>({});
//     const [data, setData] = useState<any[]>([]);
//     const [status, setStatus] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const debouncedSearchTerm = useDebounce(searchTerm, 500);
//     const [dateRange, setDateRange] = useState([new Date().toISOString().split('T')[0], '']); // Initialize with today's date

//     const handleStartDateChange = (e: any) => {
//         setDateRange([e.target.value, dateRange[1]]);
//     };

//     const handleEndDateChange = (e: any) => {
//         setDateRange([dateRange[0], e.target.value]);
//     };

//     useEffect(() => {
//         getData();
//         setOpenedRows({});
//     }, [page, limit, brand, department, status, debouncedSearchTerm, dateRange]);
//     const formatDate = (date: string) => {
//         const d = new Date(date);
//         return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
//     };

//     const getData = async () => {
//         try {
//             const response = await fetch(`/restockList`, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     page,
//                     limit,
//                     brand,
//                     transffered: status,
//                     department,
//                     searchTerm,
//                     startDate: dateRange[0],
//                     endDate: dateRange[1],
//                 }),
//             })

//             const { data, total } = await response.json();
//             if (response.status !== 200) {
//                 console.log('Unable to get the data.');
//             }

//             const uniqueStyleNos = Array.from(new Set<string>(data.map((item: any) => item.style_no)));
//             setTotalPages(total || 1);
//             setMainTableData(uniqueStyleNos.map((item: any, index: number) => ({ styleNo: item, index })));
//             setData(data.map((item: any) => {
//                 return {
//                     id: item.id,
//                     styleNo: item.style_no,
//                     location: item.location,
//                     requestedQuantity: item.requested_quantity,
//                     size: item.size,
//                     date: formatDate(item.requested_date),
//                     transferred: item.status  ?  'In Process' : 'Pending',
//                     notes: item.notes,
//                 };
//             }));
//         } catch (error) {
//             console.error(error);
//         }
//     }; 
//     //const locationOptionsData = ['DC', 'DC-Caledonia'];

//     const handleRowClick = (row: any) => {
//         if (!openedRows[row.index]) {
//             setTableData(data.filter((item: any) => item.style_no === row.styleNo).map((item: any) => {
//                 return {
//                     id: item.restock_id,
//                     styleNo: item.style_no,
//                     location: item.store,
//                     requestedQuantity: item.requested_quantity,
//                     size: item.size,
//                     date: formatDate(item.requestedat),
//                     transferred: item.transferred ? 'Yes' : 'No',
//                 };
//             }));
//             setOpenedRows({ ...openedRows, [row.index]: true });
//         } else {
//             setOpenedRows({ ...openedRows, [row.index]: false });
//         }
//     };

//     const handlePrint = async (styleCode: string) => {
//         const reportWindow = window.open('', '_blank');
//         if (!reportWindow) {
//             alert('Failed to open new window. Please check your popup blocker settings.');
//             return;
//         }
//         reportWindow.document.write('Loading report...'); // Provide immediate feedback
    
//         try {
//             // Fetch the PDF via POST request
//             const response = await fetch('/invReport', {
//                 method: 'POST',
//                 credentials:'include',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ styleCode }) // Send styleCode in the body
//             });
    
//             if (response.ok) {
//                 const blob = await response.blob();
//                 const url = window.URL.createObjectURL(blob);
//                 // Redirect the new window to the blob URL to display the PDF
//                 reportWindow.location.href = url;
//             } else {
//                 reportWindow.close(); // Close the new window if the fetch failed
//                 alert('Failed to generate report');
//             }
//         } catch (error) {
//             console.error('Error generating report:', error);
//             reportWindow.close(); // Ensure to close the new window in case of error
//             alert('An error occurred while generating the report.');
//         }
//     };
    

   
//     const handleTimeLineChange = (e: string) => {
//         const today = new Date();
//         const startOfWeek = new Date(today);
//         if (e === 'This Week') {
//             // Get the previous Saturday
//             const day = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
//             const daysSinceSaturday = day === 0 ? 1 : day + 1; // Adjust for Sunday
//             startOfWeek.setDate(today.getDate() - daysSinceSaturday);
//             setDateRange([startOfWeek.toISOString().split('T')[0], today.toISOString().split('T')[0]]);
//         } else if (e === 'Last Week') {
//             // Get the previous Friday and the week before that
//             const day = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
//             const daysSinceSaturday = day === 0 ? 1 : day + 1; // Adjust for Sunday
//             startOfWeek.setDate(today.getDate() - daysSinceSaturday);
//             const endOfWeek = new Date(startOfWeek);
//             endOfWeek.setDate(startOfWeek.getDate() - 1);
//             startOfWeek.setDate(endOfWeek.getDate() - 7);
//             setDateRange([startOfWeek.toISOString().split('T')[0], endOfWeek.toISOString().split('T')[0]]);
//         }
//     };



//     return (
//         <div>
//             <NavBar />
//             <div style={{ backgroundColor: '#F1F6F9' }}>
//                 <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
//                     <Grid p={10} align="center" columns={12} style={{ width: "90%" }}>
//                         <Grid.Col span={3}>
//                             <TextInput style={{ width: "100%" }} icon={<IconSearch />} placeholder="Search by Style No" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value.toUpperCase())} />
//                         </Grid.Col>
//                         <Grid.Col offset={1} span={5}>
//                             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                                 <div>
//                                     <Select
//                                         data={brandsData}
//                                         placeholder="Brand"
//                                         value={brand}
//                                         onChange={(e: any) => setBrand(e)}
//                                         searchable
//                                     />
//                                 </div>
//                                 <div>
//                                     <Select
//                                         data={departmentsData}
//                                         placeholder="Department"
//                                         value={department}
//                                         onChange={(e: any) => setDepartment(e)}
//                                         searchable
//                                     />
//                                 </div>
//                                 <div>
//                                     <Button
//                                         variant="outline"
//                                         onClick={() => setStatus(!status)}
//                                         style={{ color: '#212A3E' }}
//                                     >
//                                         {status ? 'Transferred' : 'Not Transferred'}
//                                     </Button>
//                                 </div>
//                                 <div>
//                                     <Select
//                                         data={['This Week', 'Last Week', 'Custom']}
//                                         placeholder="Time Line"
//                                         onChange={handleTimeLineChange}
//                                     />
//                                 </div>
//                             </div>
//                         </Grid.Col>
//                         <Grid.Col span={3}>
//                             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                                 <div>
//                                     <Input
//                                         type="date"
//                                         value={dateRange[0]}
//                                         onChange={handleStartDateChange}
//                                     />
//                                 </div>
//                                 <div>
//                                     <Input
//                                         type="date"
//                                         value={dateRange[1]}
//                                         onChange={handleEndDateChange}
//                                     />
//                                 </div>
//                             </div>
//                         </Grid.Col>
//                     </Grid>
//                 </div>
//                 <div style={{ paddingLeft: '3%', paddingRight: '3%', height: '80vh', overflow: 'auto', marginBottom: '25px', display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
//                     {/* {mainTableData.length > 0 && ( */}
//                     {mainTableData.length > 0 ? (<Table className={classes.table} verticalSpacing='sm' horizontalSpacing='sm'>
//                         <thead className={classes.thead}>
//                             <tr className={classes.th}>
//                                 <div className={classes.thd} style={{ textAlign: 'center' }}>No</div>
//                                 <div className={classes.thd} style={{ textAlign: 'center' }}>Style No</div>
//                                 {!status &&(<div className={classes.thd} style={{ textAlign: 'center' }}>Print</div>)}
//                             </tr>
//                         </thead>
//                         <tbody className={classes.tbody}>
//                             {mainTableData.map((row: any, index: number) => (
//                                 <React.Fragment key={index}>
//                                     <tr key={row.id} onClick={() => handleRowClick(row)} className={openedRows[index] === true ? classes.openedTr : classes.tr}>
//                                         <div className={classes.td} style={{ textAlign: 'center' }}>{(page - 1) * limit + index + 1}</div>
//                                         <div className={classes.td} style={{ textAlign: 'center' }}>{row.styleNo}</div>
//                                         {!status &&(<div className={classes.td} style={{ textAlign: 'center' }} onClick={() => handlePrint(row.styleNo)}><IconPrinter size={20} style={{ color: '#212A3E' }} /></div>)}
//                                     </tr>
//                                     {openedRows[index] && (<tr>
//                                         <td colSpan={2}>
//                                             <Collapse in={openedRows[index]}>
//                                                 <Table verticalSpacing='sm' horizontalSpacing='sm'>
//                                                     <thead>
//                                                         <tr className={classes.expandedTh}>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>No</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Style No</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Location</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Requested Qty</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Size</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Notes</div>
//                                                             {/* <div className={classes.expandedThd} style={{ textAlign: 'center' }}>QTY Transferred</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Action</div> */}
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Transferred</div>
//                                                             <div className={classes.expandedThd} style={{ textAlign: 'center' }}>Date</div>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {data.filter((item: any) => item.styleNo === row.styleNo).map((item: any, index: number) => (
//                                                             <tr key={item.id} className={classes.expandedTr} >
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{page * limit - limit + index + 1}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.styleNo}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.location}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.requestedQuantity}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.size}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.notes ? item.notes : 'N/A'}</div>
                                                               
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.transferred}</div>
//                                                                 <div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.date}</div>
//                                                             </tr>
//                                                         ))}
//                                                     </tbody>
//                                                 </Table>
//                                             </Collapse>
//                                         </td>
//                                     </tr>)}
//                                 </React.Fragment>
//                             ))}
//                         </tbody>
//                     </Table>) : (
//                         <Text>No data found</Text>
//                     )}
//                 </div>
//                 {tableData && (<div style={{ backgroundColor: '#394867', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginTop: '20px', position: "fixed", bottom: "0", width: "100%", height: "40px" }}>
//                     <IconArrowLeft size={30} onClick={() => setPage(page - 1 < 1 ? 1 : page - 1)} style={{ color: (page === 1 ? '#34495E' : '#F1F6F9'), cursor: 'pointer' }} />
//                     <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#F1F6F9' }}>{page} of {totalPages}</div>
//                     <IconArrowRight size={30} onClick={() => setPage(page + 1 > totalPages ? totalPages : page + 1)} style={{ color: (page === totalPages ? '#34495E' : '#F1F6F9'), cursor: 'pointer' }} />
//                 </div>)}
//             </div>
//         </div>
//     )
// }

// export default RestockRequests;

import { Button, Collapse, Grid, Input, Select, Table, Text, TextInput } from '@mantine/core';
import { IconArrowLeft, IconArrowRight, IconPrinter, IconSearch } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useDebounce } from '../Hooks/useDebounce';
import NavBar from '../Navigation/navBar';
import brandsData from './brandsData.json';
import departmentsData from './departmentsData.json';
import classes from './ReceivedRestockRequest.module.css';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
pdfMake.vfs = pdfFonts.vfs;
const fonts = {
Roboto: {
normal: 'src/fonts/Roboto-Regular.ttf',
bold: 'src/fonts/Roboto-Medium.ttf',
italics: 'src/fonts/Roboto-Italic.ttf',
bolditalics: 'src/fonts/Roboto-MediumItalic.ttf',
},
};
const RestockRequests: React.FC = () => {
const [tableData, setTableData] = useState<any[]>([]);
const [mainTableData, setMainTableData] = useState<any[]>([]);
const [page, setPage] = useState(1);
const [limit, setLimit] = useState(10);
const [totalPages, setTotalPages] = useState(1);
const [brand, setBrand] = useState('');
const [department, setDepartment] = useState('');
const [openedRows, setOpenedRows] = useState<{ [index: number]: boolean }>({});
const [data, setData] = useState<any[]>([]);
const [status, setStatus] = useState(false);
const [searchTerm, setSearchTerm] = useState('');
const debouncedSearchTerm = useDebounce(searchTerm, 500);
const [dateRange, setDateRange] = useState([new Date().toISOString().split('T')[0], '']); // Initialize with today's date

const handleStartDateChange = (e: any) => {
setDateRange([e.target.value, dateRange[1]]);
};

const handleEndDateChange = (e: any) => {
setDateRange([dateRange[0], e.target.value]);
};

useEffect(() => {
getData();
setOpenedRows({});
}, [page, limit, brand, department, status, debouncedSearchTerm, dateRange]);
const formatDate = (date: string) => {
const d = new Date(date);
return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

const getData = async () => {
try {
const response = await fetch(`/restockList`, {
method: 'POST',
credentials: "include",
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({
page,
limit,
brand,
transffered: status,
department,
searchTerm,
startDate: dateRange[0],
endDate: dateRange[1],
}),
})

const { data, total } = await response.json();
if (response.status !== 200) {
console.log('Unable to get the data.');
}

const uniqueStyleNos = Array.from(new Set<string>(data.map((item: any) => item.style_no)));
setTotalPages(total || 1);
setMainTableData(uniqueStyleNos.map((item: any, index: number) => ({ styleNo: item, index })));
setData(data.map((item: any) => {
return {
id: item.id,
styleNo: item.style_no,
location: item.location,
requestedQuantity: item.requested_quantity,
size: item.size,
date: formatDate(item.requested_date),
transferred: item.status ? 'In Process' : 'Pending',
notes: item.notes,
};
}));
} catch (error) {
console.error(error);
}
};
//const locationOptionsData = ['DC', 'DC-Caledonia'];

const handleRowClick = (row: any) => {
if (!openedRows[row.index]) {
setTableData(data.filter((item: any) => item.style_no === row.styleNo).map((item: any) => {
return {
id: item.restock_id,
styleNo: item.style_no,
location: item.store,
requestedQuantity: item.requested_quantity,
size: item.size,
sku: item.PLU_SKU,
date: formatDate(item.requestedat),
transferred: item.transferred ? 'Yes' : 'No',
};
}));
setOpenedRows({ ...openedRows, [row.index]: true });
} else {
setOpenedRows({ ...openedRows, [row.index]: false });
}
};
const generateReport = (data: any, styleData: any) => {
const tableData = data.map((item: any) => {
const currentRow = styleData.find((itm: any) => (itm.styleNo === item.styleCode && itm.size === item.Size));
return {
sku: item.PLU_SKU,
styleNo: item.styleCode,
supplier: item.Supplier,
bin: item.BIN,
description: item.Description,
color: item.Color,
size: item.Size,
ohQty: item.OHQty,
cost: item.AvgCost,
reqQty: currentRow?.requestedQuantity || 0,
}
}).filter((item: any) => item);
const styleNo = styleData[0].styleNo;
const totalOhQty = tableData.reduce((acc: number, item: any) => acc + item.ohQty, 0);
const totalReqQty = tableData.reduce((acc: number, item: any) => acc + item.reqQty, 0);
let contentData: Content[] = [{
text: `Inventory Details By- Style# ${styleNo}`,
style: 'header',
alignment: 'center',
fontSize: 20,
bold: true,
margin: [0, 0, 0, 0]
}, {
table: {
headerRows: 1,
widths: [55, 90, 30, 130, 95, 40, 50, 40, 50, 50, 50],
body: [
// Apply tableHeader style to header row
[
{ text: 'PLU SKU', style: 'tableHeader' },
{ text: 'Supplier', style: 'tableHeader' },
{ text: 'BIN', style: 'tableHeader' },
{ text: 'Description', style: 'tableHeader' },
{ text: 'Color', style: 'tableHeader' },
{ text: 'Size', style: 'tableHeader' },
{ text: 'O/H QTY', style: 'tableHeader' },
{ text: 'Req Qty', style: 'tableHeader' },
{ text: 'Pick Qty', style: 'tableHeader' },
{ text: 'Avg. Cost', style: 'tableHeader' },
{ text: 'Picked By', style: 'tableHeader' }
],
// Apply tableBody style to each data row
...tableData.map((item: any) => [
{ text: item.sku, style: 'tableBody' },
{ text: item.supplier, style: 'tableBody' },
{ text: item.bin, style: 'tableBody' },
{ text: item.description, style: 'tableBody' },
{ text: item.color, style: 'tableBody' },
{ text: item.size, style: 'tableBody' },
{ text: item.ohQty, style: 'tableBody' },
{ text: item.reqQty, style: 'tableBody' },
{ text: '', style: 'tableBody' }, // Pick Qty
{ text: item.cost, style: 'tableBody' },
{ text: '', style: 'tableBody' } // Picked By
]),
[
{ text: '', style: 'tableBody' },
{ text: `${data[0].Location_ID}`, style: 'tableHeader' },
{ text: '', style: 'tableBody' },
{ text: `${data[0].Supplier}`, style: 'tableHeader' },
{ text: `${data[0].styleCode} \n ${data[0].Color}`, style: 'tableHeader' },
{ text: 'Total', style: 'tableHeader' },
{ text: `${totalOhQty}`, style: 'tableHeader' },
{ text: `${totalReqQty}`, style: 'tableHeader' },
{ text: '', style: 'tableBody' },
{ text: '', style: 'tableBody' },
{ text: '', style: 'tableBody' }
]
]
},
margin: [-33, 0, 0, 0]
}];
const docDefinition: TDocumentDefinitions = {
content: contentData,
pageSize: 'LETTER',
// pageMargins: [5, 5, 5, 5],
styles: {
header: {
fontSize: 20,
bold: true,
alignment: 'center',
margin: [0, 0, 0, 30],
},
tableHeader: {
bold: true,
fontSize: 13,
alignment: 'center',
color: 'black'
},
tableBody: {
fontSize: 10,
alignment: 'center',
margin: [0, 0, 0, 0]
},
},
pageOrientation: 'landscape',
};

pdfMake.createPdf(docDefinition).open();
}

const handlePrint = async (row: any) => {
try {
const response = await fetch('/invReport', {
method: 'POST',
credentials: 'include',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({ styleCode: row[0].styleNo }) // Send styleCode in the body
});

if (response.ok) {
const data = await response.json();
generateReport(data, row);
} else {
alert('Failed to generate report');
}
} catch (error) {
console.error('Error generating report:', error);
alert('An error occurred while generating the report.');
}
};



const handleTimeLineChange = (e: string) => {
const today = new Date();
const startOfWeek = new Date(today);
if (e === 'This Week') {
// Get the previous Saturday
const day = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
const daysSinceSaturday = day === 0 ? 1 : day + 1; // Adjust for Sunday
startOfWeek.setDate(today.getDate() - daysSinceSaturday);
setDateRange([startOfWeek.toISOString().split('T')[0], today.toISOString().split('T')[0]]);
} else if (e === 'Last Week') {
// Get the previous Friday and the week before that
const day = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
const daysSinceSaturday = day === 0 ? 1 : day + 1; // Adjust for Sunday
startOfWeek.setDate(today.getDate() - daysSinceSaturday);
const endOfWeek = new Date(startOfWeek);
endOfWeek.setDate(startOfWeek.getDate() - 1);
startOfWeek.setDate(endOfWeek.getDate() - 7);
setDateRange([startOfWeek.toISOString().split('T')[0], endOfWeek.toISOString().split('T')[0]]);
}
};



return (
<div>
<NavBar />
<div style={{ backgroundColor: '#F1F6F9' }}>
<div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
<Grid p={10} align="center" columns={12} style={{ width: "90%" }}>
<Grid.Col span={3}>
<TextInput style={{ width: "100%" }} icon={<IconSearch />} placeholder="Search by Style No" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value.toUpperCase())} />
</Grid.Col>
<Grid.Col offset={1} span={5}>
<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
<div>
<Select
data={brandsData}
placeholder="Brand"
value={brand}
onChange={(e: any) => setBrand(e)}
searchable
/>
</div>
<div>
<Select
data={departmentsData}
placeholder="Department"
value={department}
onChange={(e: any) => setDepartment(e)}
searchable
/>
</div>
<div>
<Button
variant="outline"
onClick={() => setStatus(!status)}
style={{ color: '#212A3E' }}
>
{status ? 'Transferred' : 'Not Transferred'}
</Button>
</div>
<div>
<Select
data={['This Week', 'Last Week', 'Custom']}
placeholder="Time Line"
onChange={handleTimeLineChange}
/>
</div>
</div>
</Grid.Col>
<Grid.Col span={3}>
<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
<div>
<Input
type="date"
value={dateRange[0]}
onChange={handleStartDateChange}
/>
</div>
<div>
<Input
type="date"
value={dateRange[1]}
onChange={handleEndDateChange}
/>
</div>
</div>
</Grid.Col>
</Grid>
</div>
<div style={{ paddingLeft: '3%', paddingRight: '3%', height: '80vh', overflow: 'auto', marginBottom: '25px', display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
{/* {mainTableData.length > 0 && ( */}
{mainTableData.length > 0 ? (<Table className={classes.table} verticalSpacing='sm' horizontalSpacing='sm'>
<thead className={classes.thead}>
<tr className={classes.th}>
<div className={classes.thd} style={{ textAlign: 'center' }}>No</div>
<div className={classes.thd} style={{ textAlign: 'center' }}>Style No</div>
{!status && (<div className={classes.thd} style={{ textAlign: 'center' }}>Print</div>)}
</tr>
</thead>
<tbody className={classes.tbody}>
{mainTableData.map((row: any, index: number) => (
<React.Fragment key={index}>
<tr key={row.id} onClick={() => handleRowClick(row)} className={openedRows[index] === true ? classes.openedTr : classes.tr}>
<div className={classes.td} style={{ textAlign: 'center' }}>{(page - 1) * limit + index + 1}</div>
<div className={classes.td} style={{ textAlign: 'center' }}>{row.styleNo}</div>
{!status && (<div className={classes.td} style={{ textAlign: 'center' }} onClick={() => handlePrint(data.filter((item: any) => item.styleNo === row.styleNo))}><IconPrinter size={20} style={{ color: '#212A3E' }} /></div>)}
</tr>
{openedRows[index] && (<tr>
<td colSpan={2}>
<Collapse in={openedRows[index]}>
<Table verticalSpacing='sm' horizontalSpacing='sm'>
<thead>
<tr className={classes.expandedTh}>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>No</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Style No</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Location</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Requested Qty</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Size</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Notes</div>
{/* <div className={classes.expandedThd} style={{ textAlign: 'center' }}>QTY Transferred</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Action</div> */}
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Transferred</div>
<div className={classes.expandedThd} style={{ textAlign: 'center' }}>Date</div>
</tr>
</thead>
<tbody>
{data.filter((item: any) => item.styleNo === row.styleNo).map((item: any, index: number) => (
<tr key={item.id} className={classes.expandedTr} >
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{page * limit - limit + index + 1}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.styleNo}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.location}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.requestedQuantity}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.size}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.notes ? item.notes : 'N/A'}</div>

<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.transferred}</div>
<div className={classes.expandedTd} style={{ textAlign: 'center' }}>{item.date}</div>
</tr>
))}
</tbody>
</Table>
</Collapse>
</td>
</tr>)}
</React.Fragment>
))}
</tbody>
</Table>) : (
<Text>No data found</Text>
)}
</div>
{tableData && (<div style={{ backgroundColor: '#394867', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginTop: '20px', position: "fixed", bottom: "0", width: "100%", height: "40px" }}>
<IconArrowLeft size={30} onClick={() => setPage(page - 1 < 1 ? 1 : page - 1)} style={{ color: (page === 1 ? '#34495E' : '#F1F6F9'), cursor: 'pointer' }} />
<div style={{ fontWeight: 'bold', fontSize: '18px', color: '#F1F6F9' }}>{page} of {totalPages}</div>
<IconArrowRight size={30} onClick={() => setPage(page + 1 > totalPages ? totalPages : page + 1)} style={{ color: (page === totalPages ? '#34495E' : '#F1F6F9'), cursor: 'pointer' }} />
</div>)}
</div>
</div>
)
}

export default RestockRequests;